import './observableInternal/index.js';
import { constObservable } from './observableInternal/observables/constObservable.js';

/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/
function readHotReloadableExport(value, reader) {
    return value;
}
function createHotClass(clazz) {
    {
        return constObservable(clazz);
    }
}

export { createHotClass, readHotReloadableExport };
